import styled from '@emotion/styled';
import {
  space,
  SpaceProps,
  layout,
  LayoutProps,
  border,
  BorderProps,
  flexbox,
  FlexboxProps,
  shadow,
  ShadowProps,
  color,
} from 'styled-system';
import shouldForwardProp from '@styled-system/should-forward-prop';

import {BackgroundColorProps} from '../custom-types';

type RowProps = SpaceProps &
  LayoutProps &
  BorderProps &
  FlexboxProps &
  ShadowProps &
  BackgroundColorProps;

export const Row = styled('div', {shouldForwardProp})<RowProps>`
  ${space};
  ${layout};
  ${border};
  ${flexbox};
  ${shadow};
  ${color};
  display: flex;
  flex-direction: row;
`;
